export default __webpack_public_path__ + "static/heroSectionBackground-38ae08c9d011cf69a89031002efcf652.png";